module.exports = __webpack_public_path__ + "static/media/nc.4ff146bc.svg";